import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './MobileCookiePreferencesPage.css';

const sections = (onCookiesPolicy) => [
  {
    title: 'About Cookies',
    body: (
      <>
        We and selected partners use cookies and similar tools (collectively, &quot;Cookies&quot;) when you visit our platform
        to provide services, understand how you interact with our platform, offer a personalized experience, serve for
        marketing purpose, and/or share content on third-party websites. You can always change your Cookie preferences at
        any time. To learn more about our use of Cookies, please visit our{' '}
        <button type="button" className="mcook-link" onClick={onCookiesPolicy}>
          Cookies Policy
        </button>
        .
      </>
    )
  },
  {
    title: 'Essential Cookies',
    body: `These Cookies are strictly necessary for enabling access and use of our Platform. They provide necessary functionality to ensure the proper performance, security and functionality of our Platform. These Cookies cannot be disabled. You may set your browser to block or alert you about these Cookies but some parts of our Platform will not then work.`
  },
  {
    title: 'Statistical Cookies',
    body: `These Cookies help us determine and understand how users interact with and use our Platform. We use this information to help us to improve and optimize our Platform and its security.`
  },
  {
    title: 'Personalization and Service Cookies',
    body: `These Cookies are used to recommend content more relevant to you based on what you've viewed previously. This prevents repeated content and may help select interest-based advertisements. We and our third-party advertising service providers do not use these Cookies for Cross-context Behavioral Advertising (as defined below), and the collected data will not be shared with data brokers.`
  },
  {
    title: 'Marketing Cookies',
    body: `Our Platform and/or third-party advertising service providers may use these Cookies to collect and use your personal information for Cross-context Behavioral Advertising purposes. "Cross-context Behavioral Advertising" (or sometimes also known as targeted advertising) refers to displaying targeted advertisements to you on one site based on your information collected from a different and non-affiliated site (including across devices). You can adjust your preferences for these Cookies in your account or device settings where available.`
  }
];

export default function MobileCookiePreferencesPage() {
  const navigate = useNavigate();
  const goPolicy = useCallback(() => {
    navigate('/mobile/legal/privacy');
  }, [navigate]);
  const list = sections(goPolicy);

  return (
    <div className="mcook-page">
      <header className="mcook-header">
        <button type="button" className="mcook-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mcook-title">Cookie Preferences</h1>
      </header>
      <div className="mcook-scroll">
        {list.map((s) => (
          <section key={s.title} className="mcook-block">
            <h2 className="mcook-h2">{s.title}</h2>
            <div className="mcook-line" />
            <div className="mcook-p">{typeof s.body === 'string' ? s.body : s.body}</div>
          </section>
        ))}
      </div>
    </div>
  );
}
